import { render, staticRenderFns } from "./Workload_analysis.vue?vue&type=template&id=145a67ae&style=true"
import script from "./Workload_analysis.vue?vue&type=script&lang=js"
export * from "./Workload_analysis.vue?vue&type=script&lang=js"
import style0 from "./Workload_analysis.vue?vue&type=style&index=0&id=145a67ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports